import { render } from "./PricingCards.vue?vue&type=template&id=3f04a1af&ts=true"
import script from "./PricingCards.vue?vue&type=script&lang=ts"
export * from "./PricingCards.vue?vue&type=script&lang=ts"

import "./PricingCards.vue?vue&type=style&index=0&id=3f04a1af&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__